import { Shield } from "lucide-react";
import { ScrollReveal } from "./ScrollReveal";

export const GuaranteeSection = () => {
  return (
    <section className="py-12 md:py-20 relative" style={{ background: "#FFFFFF" }}>
      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <ScrollReveal>
          <div className="max-w-3xl mx-auto text-center">
            <div className="inline-flex items-center justify-center w-[72px] h-[72px] rounded-2xl mb-6 md:mb-8" style={{ background: "rgba(124,58,237,0.08)" }}>
              <Shield className="w-10 h-10" style={{ color: "#7C3AED" }} />
            </div>
            <h2 className="font-display font-bold mb-4 md:mb-6 leading-tight" style={{ color: "#111827", fontSize: "clamp(24px, 3.5vw, 40px)" }}>
              The 60-Day{" "}
              <span style={{ color: "#F59E0B" }}>First Results</span> Guarantee
            </h2>
            <p className="text-sm md:text-lg leading-relaxed mb-4 md:mb-6 max-w-2xl mx-auto" style={{ color: "#4B5563" }}>
              We guarantee you'll make your first sale or hit your first 1,000 views within 60 days of
              using AI StoryCraft Studio — or our team will personally review your content, your product,
              and your strategy and tell you exactly what to fix. We don't offer refunds. We offer
              something better: <span className="font-semibold" style={{ color: "#111827" }}>we fix the problem.</span>
            </p>
            <p className="text-xs md:text-sm italic" style={{ color: "#9CA3AF" }}>
              This guarantee is only possible because we know the system works — at any audience size.
            </p>
          </div>
        </ScrollReveal>
      </div>
    </section>
  );
};
